<!-- #################### OLD MAIN VIEW #################### -->
<div *ngIf="!sidebar">
	<div
		class="sortWrapper old d-flex"
		[ngClass]="{
		'activeOperation': activeOperation && !showBody,
		'isOpen': showBody
	}"
	>

		<div
			class="d-flex"
			[ngClass]="{ 'active': activeSort }"
		>
			<i
				class="operator-icon fa fa-sort-amount-down vertical-separator--right"
				(click)="toggleBodyVisibility()"
			></i>

			<div
				class="d-flex flex-column operator-order"
				[ngClass]="{'disabled': !sort || sort?.length === 0}"
				(click)="toggleSortOrder()"
			>
				<i
					class="my-auto fa"
					[ngClass]="{
						'fa-sort-up': sortOrder === sortOrderEnum.ASC,
						'fa-sort-down': sortOrder === sortOrderEnum.DESC
						}"
				></i>
			</div>

			<div
				class="operator-title toggle-sort"
				(click)="toggleBodyVisibility()"
			>
				<span>
					{{ getI18nString( false, 'shared.listOperations.sort' )  }}
				</span>
			</div>
		</div>

		<div class="operator-body">
			<ul class="px-3 m-0">
				<ng-container *ngFor="let item of sortData">
					<li
						class="hyphens-none"
						[ngClass]="{'active': activeSort === item?.name}"
						(click)="emitSortChanges( item?.name )"
					>
						<app-svg
							[svgStyleClass]="'position-absolute'"
							[type]="svgTypeEnum.CHECK"
						></app-svg>

						{{ getI18nString( false, item?.i18nPath )  }}
					</li>
				</ng-container>
			</ul>
		</div>
	</div>
</div>

<!-- #################### NEW MAIN VIEW #################### -->
<div *ngIf="sidebar">
	<div class="sortWrapper sidebar">
		<div class="d-flex">
			<i class="operator-icon fa fa-sort-amount-down vertical-separator--right"></i>

			<div
				class="d-flex flex-column operator-order"
				[ngClass]="{'disabled': !sort || sort?.length === 0}"
				(click)="toggleSortOrder()"
			>
				<i
					class="my-auto fa"
					[ngClass]="{
						'fa-sort-up': sortOrder === sortOrderEnum.ASC,
						'fa-sort-down': sortOrder === sortOrderEnum.DESC
					}"
				></i>
			</div>

			<div class="operator-title">
				<span>
					{{ getI18nString( false, 'shared.listOperations.sort' )  }}
				</span>
			</div>
		</div>

		<div class="operator-body">
			<ul class="px-3 m-0">
				<ng-container *ngFor="let item of sortData">
					<li
						[ngClass]="{'active': activeSort === item?.name}"
						(click)="emitSortChanges( item?.name )"
					>
						<app-svg
							[svgStyleClass]="'position-absolute'"
							[type]="svgTypeEnum.CHECK"
						></app-svg>
						{{ getI18nString( false, item?.i18nPath )  }}
					</li>
				</ng-container>
			</ul>
		</div>
	</div>
</div>
